import { render, staticRenderFns } from "./translatable.vue?vue&type=template&id=8478a06a&scoped=true&"
import script from "./translatable.vue?vue&type=script&lang=js&"
export * from "./translatable.vue?vue&type=script&lang=js&"
import style0 from "./translatable.vue?vue&type=style&index=0&id=8478a06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8478a06a",
  null
  
)

export default component.exports